import styled from 'styled-components';
import { font, breakpoint } from 'styles/globals';
import { getColor, type Theme } from 'styles/theme';
import Heading from 'styles/typography/Heading';

export const AuthorGridLayout = styled.div<{ theme: Theme }>`
  display: grid;
  grid-template-columns: 70fr 30fr;
  grid-template-rows: auto 60px 1fr;
  padding: 0 16px;

  .author-hero {
    grid-area: 1 / 1 / 2 / 2;
    border-bottom: ${getColor('borderSecondary')} 1px solid;
    margin-bottom: 12px;
  }
  .sidebar {
    grid-area: 1 / 2 / 4 / 3;
  }
  .author-pages {
    grid-area: 2 / 1 / 3 / 2;
  }
  .articles {
    grid-area: 3 / 1 / 4 / 2;
  }

  @media (${breakpoint.hybridMax}) {
    grid-template-columns: 100fr;
  }
`;

export const AuthorSideBar = styled.div`
  margin-left: 48px;
  margin-top: 48px;

  @media (${breakpoint.hybridMax}) {
    display: none;
  }

  .side-ad {
      margin-bottom: 48px;
    }
`;

export const NoArticles = styled.span<{ theme: Theme }>`
  color: ${getColor('neutralBlack')};
  font-family: ${font.graphikCond};
  font-weight: 500;
`;

export const PageInfo = styled(Heading)<{ theme: Theme }>`
  padding-top: 8px;
  align-self: flex-start;
  font-weight: 400;
  line-height: 150%;

  &.author {
    padding-top: unset;
  }
`;

export const AuthorWrapper = styled.div`
  padding: 0px 16px;
  margin-bottom: 32px;
  @media (${breakpoint.mdMin}) {
    padding: 0;
  }
`;
